import type {
  School,
  User,
  Course,
  Lesson,
  Batch,
  Channel,
  Thread,
  Message,
  Notification,
  DashboardOverview,
  Certificate,
  Quiz,
  QuizQuestion,
  Flashcard,
  AdminUser,
  AdminAnalytics,
  Payment,
  Bookmark,
  Note,
  CalendarEvent,
  Assignment,
} from 'types';

export const mockUsers: User[] = [
  {
    id: 'user-1',
    email: 'arjun.sharma@example.com',
    firstName: 'Arjun',
    lastName: 'Sharma',
    roles: ['student'],
    hasApprovedMembership: true,
    institutionNames: ['Parashari Gurukul'],
    createdAt: '2025-01-15T10:00:00Z',
  },
  {
    id: 'user-admin',
    email: 'admin@takshify.com',
    firstName: 'Priya',
    lastName: 'Kant',
    roles: ['super_admin'],
    createdAt: '2024-06-01T10:00:00Z',
  },
  {
    id: 'user-teacher-1',
    email: 'dr.mehta@takshify.com',
    firstName: 'Rajesh',
    lastName: 'Mehta',
    roles: ['teacher'],
    createdAt: '2024-06-01T10:00:00Z',
  },
];

export const mockSchools: School[] = [
  {
    id: 'school-1',
    slug: 'parashari',
    name: 'Parashari Jyotish',
    shortName: 'Parashari',
    description:
      'Master classical Vedic astrology through the Parashari system - houses, dashas, yogas, and predictive techniques passed down through generations of acharyas.',
    icon: 'orbit',
    status: 'active',
    difficulty: 'intermediate',
    estimatedDuration: '18 months',
    studentCount: 4280,
    progress: 34,
    sortOrder: 1,
    themeKey: 'parashari',
    isPremium: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-2',
    slug: 'jaimini',
    name: 'Jaimini Astrology',
    shortName: 'Jaimini',
    description:
      'Explore the Jaimini system of karakas, chara dashas, and pada lagna - a precise, research-oriented approach to chart analysis and timing.',
    icon: 'network',
    status: 'active',
    difficulty: 'advanced',
    estimatedDuration: '24 months',
    studentCount: 2150,
    progress: 12,
    sortOrder: 2,
    themeKey: 'jaimini',
    isPremium: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-3',
    slug: 'kp',
    name: 'KP Astrology',
    shortName: 'KP',
    description:
      'Krishnamurti Paddhati - sub-lord theory, cuspal interlinks, and event-focused prediction with scientific precision.',
    icon: 'grid',
    status: 'active',
    difficulty: 'intermediate',
    estimatedDuration: '12 months',
    studentCount: 0,
    sortOrder: 3,
    themeKey: 'kp',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-4',
    slug: 'bnn',
    name: 'Bhrigu Nandi Nadi',
    shortName: 'BNN',
    description:
      'Bhrigu Nandi Nadi - karakatwa-based prediction without Lagna or Dashas. Master planetary sambandha, transit timing, and instant chart reading.',
    icon: 'link',
    status: 'active',
    difficulty: 'expert',
    estimatedDuration: '36 months',
    studentCount: 0,
    sortOrder: 4,
    themeKey: 'bnn',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-22',
    slug: 'lal-kitab',
    name: 'Lal Kitab',
    shortName: 'Lal Kitab',
    description:
      'Roop Chand Joshi\'s Lal Kitab - fixed houses, astro-palmistry, karmic debts, Varshphal, and practical Upayas for everyday remedy.',
    icon: 'book',
    status: 'active',
    difficulty: 'intermediate',
    estimatedDuration: '12 weeks',
    studentCount: 0,
    sortOrder: 8,
    themeKey: 'lal-kitab',
    isPremium: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-5',
    slug: 'numerology',
    name: 'Numerology (Chaldean)',
    shortName: 'Numerology',
    description:
      'Chaldean sound-based numerology - Mulank, Bhagyank, compound numbers 10–52, name analysis, and professional practice.',
    icon: 'hash',
    status: 'active',
    difficulty: 'beginner',
    estimatedDuration: '6 months',
    studentCount: 0,
    sortOrder: 5,
    themeKey: 'numerology',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-6',
    slug: 'panchang',
    name: 'Panchang',
    shortName: 'Panchang',
    description:
      'Learn the Hindu calendar system - tithis, nakshatras, yogas, karanas, balas, doshas, and muhurta selection for auspicious timing.',
    icon: 'calendar',
    status: 'active',
    difficulty: 'beginner',
    estimatedDuration: '8 months',
    studentCount: 0,
    sortOrder: 6,
    themeKey: 'panchang',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-7',
    slug: 'sanskrit',
    name: 'Sanskrit',
    shortName: 'Sanskrit',
    description:
      'Build fluency in the language of the Vedas - grammar, chanting, and scriptural reading for deeper access to primary texts.',
    icon: 'book',
    status: 'coming_soon',
    difficulty: 'beginner',
    estimatedDuration: '24 months',
    studentCount: 0,
    sortOrder: 7,
    themeKey: 'default',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-8',
    slug: 'surya-siddhanta',
    name: 'Surya Siddhanta',
    shortName: 'Surya Siddhanta',
    description:
      'Classical Ganita Jyotish - Mahayuga time cycles, planetary periods, Lahiri ayanamsha, and Panchang limb preview.',
    icon: 'sun',
    status: 'active',
    difficulty: 'advanced',
    estimatedDuration: '18 months',
    studentCount: 0,
    sortOrder: 8,
    themeKey: 'surya-siddhanta',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-9',
    slug: 'ai-tutor',
    name: 'AskGuru',
    shortName: 'AskGuru',
    description:
      'Your personal AI learning companion - ask questions, get explanations, generate quizzes, and accelerate your study across all schools.',
    icon: 'bot',
    status: 'active',
    difficulty: 'beginner',
    estimatedDuration: 'Ongoing',
    studentCount: 0,
    sortOrder: 9,
    themeKey: 'default',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-10',
    slug: 'community',
    name: 'Guru–Sadhak Sangha',
    shortName: 'Sangha',
    description:
      'A living sangha where gurus guide seekers and sadhaks learn together - moderated channels, weekly satsang threads, and school-scoped study circles across every path.',
    icon: 'users',
    status: 'active',
    difficulty: 'beginner',
    estimatedDuration: 'Ongoing',
    studentCount: 8500,
    sortOrder: 10,
    themeKey: 'default',
    isPremium: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-11',
    slug: 'certifications',
    name: 'Verified Certificates',
    shortName: 'Certificates',
    description:
      'Institute-backed digital credentials with shareable verification codes - honour your marga from Abhyas completion through diploma and postgraduate programs.',
    icon: 'award',
    status: 'active',
    difficulty: 'intermediate',
    estimatedDuration: 'Varies',
    studentCount: 1200,
    sortOrder: 11,
    themeKey: 'default',
    isPremium: false,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-12',
    slug: 'palmistry',
    name: 'Palmistry',
    shortName: 'Palmistry',
    description:
      'Learn Hasta Samudrika Shastra - mounts, lines, and signs of the hand as a living map of temperament, karma, and life events.',
    icon: 'hand',
    status: 'coming_soon',
    difficulty: 'beginner',
    estimatedDuration: '10 months',
    studentCount: 0,
    sortOrder: 12,
    themeKey: 'palmistry',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-13',
    slug: 'tantra',
    name: 'Tantra',
    shortName: 'Tantra',
    description:
      'Thirty-two bilingual lessons on Tantric foundations - traditions, mantra and yantra vocabulary, cross-links with Yoga and Jyotisha, and ethical study boundaries.',
    icon: 'flame',
    status: 'active',
    difficulty: 'advanced',
    estimatedDuration: '24 months',
    studentCount: 0,
    sortOrder: 13,
    themeKey: 'tantra',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2026-07-14T00:00:00Z',
  },
  {
    id: 'school-14',
    slug: 'swara-vigyan',
    name: 'Swara Vigyan',
    shortName: 'Swara Vigyan',
    description:
      'Learn which nostril is active, moon-day rules at sunrise, and when to eat, travel, study, or rest - in plain language.',
    icon: 'wind',
    status: 'active',
    difficulty: 'intermediate',
    estimatedDuration: '12 months',
    studentCount: 0,
    sortOrder: 14,
    themeKey: 'swara-vigyan',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-15',
    slug: 'vastu',
    name: 'Vastu Shastra',
    shortName: 'Vastu',
    description:
      'Align built space with directional energies - Vastu Purusha mandala, residential and commercial zoning, padas, and floor-plan audit.',
    icon: 'layout',
    status: 'active',
    difficulty: 'intermediate',
    estimatedDuration: '14 months',
    studentCount: 0,
    sortOrder: 15,
    themeKey: 'vastu',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-15b',
    slug: 'yantra-vidya',
    name: 'Yantra Vidya',
    shortName: 'Yantra Vidya',
    description:
      'Twenty-five lessons with sacred geometry drawn step by step - bindu, triangles, lotus, gates, yantra types, and how to read yantra layers.',
    icon: 'hexagon',
    status: 'active',
    difficulty: 'intermediate',
    estimatedDuration: '10 months',
    studentCount: 0,
    sortOrder: 16,
    themeKey: 'yantra-vidya',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-16',
    slug: 'ayurveda',
    name: 'Ayurveda',
    shortName: 'Ayurveda',
    description:
      'Explore the science of life - doshas, dinacharya, and holistic wellness rooted in classical Ayurvedic texts.',
    icon: 'leaf',
    status: 'coming_soon',
    difficulty: 'beginner',
    estimatedDuration: '18 months',
    studentCount: 0,
    sortOrder: 16,
    themeKey: 'ayurveda',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-17',
    slug: 'yoga',
    name: 'Yoga',
    shortName: 'Yoga',
    description:
      'Learn classical yoga as a path of discipline - asana, pranayama, and philosophy from Patanjali and the living tradition.',
    icon: 'activity',
    status: 'coming_soon',
    difficulty: 'beginner',
    estimatedDuration: '12 months',
    studentCount: 0,
    sortOrder: 17,
    themeKey: 'yoga',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-18',
    slug: 'vedanta',
    name: 'Vedanta',
    shortName: 'Vedanta',
    description:
      'Study the culmination of Vedic wisdom - Brahman, Atman, and the non-dual vision of the Upanishadic sages.',
    icon: 'sparkles',
    status: 'coming_soon',
    difficulty: 'advanced',
    estimatedDuration: '24 months',
    studentCount: 0,
    sortOrder: 18,
    themeKey: 'vedanta',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-19',
    slug: 'bhagavad-gita',
    name: 'Bhagavad Gita',
    shortName: 'Gita',
    description:
      'Engage with the song of the Lord - karma yoga, bhakti, and jnana through structured study of all eighteen chapters.',
    icon: 'scroll',
    status: 'coming_soon',
    difficulty: 'intermediate',
    estimatedDuration: '10 months',
    studentCount: 0,
    sortOrder: 19,
    themeKey: 'bhagavad-gita',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-20',
    slug: 'upanishads',
    name: 'Upanishads',
    shortName: 'Upanishads',
    description:
      'Dive into the secret teachings of the Vedas - Tat Tvam Asi, consciousness, and the path to self-knowledge.',
    icon: 'book-open',
    status: 'coming_soon',
    difficulty: 'advanced',
    estimatedDuration: '16 months',
    studentCount: 0,
    sortOrder: 20,
    themeKey: 'upanishads',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
  {
    id: 'school-21',
    slug: 'indian-philosophy',
    name: 'Indian Philosophy',
    shortName: 'Philosophy',
    description:
      'Survey the darshanas - Nyaya, Vaisheshika, Samkhya, Yoga, Mimamsa, and Vedanta as living systems of thought.',
    icon: 'brain',
    status: 'coming_soon',
    difficulty: 'intermediate',
    estimatedDuration: '20 months',
    studentCount: 0,
    sortOrder: 21,
    themeKey: 'indian-philosophy',
    isPremium: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2025-06-01T00:00:00Z',
  },
];

export const mockCourses: Course[] = [
  {
    id: 'course-1',
    schoolId: 'school-1',
    schoolSlug: 'parashari',
    title: 'Parashari Foundation',
    description:
      'A comprehensive introduction to Parashari Jyotish - rashi, bhava, graha, and the fundamentals of chart reading.',
    difficulty: 'beginner',
    duration: '6 months',
    lessonCount: 48,
    enrolledCount: 3200,
    progress: 34,
    instructorName: 'Dr. Rajesh Mehta',
    createdAt: '2024-03-01T00:00:00Z',
  },
  {
    id: 'course-2',
    schoolId: 'school-1',
    schoolSlug: 'parashari',
    title: 'Advanced Dashas & Yogas',
    description:
      'Deep dive into Vimshottari dasha, yoga formations, and predictive techniques for real-world chart analysis.',
    difficulty: 'advanced',
    duration: '8 months',
    lessonCount: 36,
    enrolledCount: 890,
    progress: 0,
    instructorName: 'Dr. Rajesh Mehta',
    createdAt: '2024-06-01T00:00:00Z',
  },
  {
    id: 'course-3',
    schoolId: 'school-2',
    schoolSlug: 'jaimini',
    title: 'Jaimini Astrology',
    description:
      'The complete Jaimini system - chara karakas, rashi drishti, arudha padas, chara dasha, and predictive yogas on the birth chart.',
    difficulty: 'beginner',
    duration: '8–12 weeks',
    lessonCount: 42,
    enrolledCount: 1100,
    progress: 0,
    instructorName: 'Prof. Ananya Desai',
    createdAt: '2024-04-01T00:00:00Z',
  },
];

export const mockLessons: Lesson[] = [
  {
    id: 'lesson-1',
    moduleId: 'mod-1',
    courseId: 'course-1',
    title: 'Introduction to the Zodiac Signs',
    description:
      'Understanding the twelve rashis, their lords, elements, and qualities - the foundation of all chart interpretation.',
    duration: 2400,
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    sortOrder: 1,
    isCompleted: true,
  },
  {
    id: 'lesson-2',
    moduleId: 'mod-1',
    courseId: 'course-1',
    title: 'The Twelve Houses (Bhavas)',
    description:
      'Each bhava represents a domain of life - learn their significations, karakatwas, and how to read house lords.',
    duration: 3000,
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
    sortOrder: 2,
    isCompleted: false,
  },
  {
    id: 'lesson-3',
    moduleId: 'mod-2',
    courseId: 'course-1',
    title: 'Planetary Strengths and Weaknesses',
    description:
      'Shadbala, dignity, combustion, and retrogression - assessing graha bala for accurate predictions.',
    duration: 2700,
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
    sortOrder: 3,
    isCompleted: false,
  },
];

export const mockBatches: Batch[] = [
  {
    id: 'batch-1',
    schoolId: 'school-1',
    schoolSlug: 'parashari',
    name: 'Parashari Foundation Batch 2026',
    description:
      'Join our flagship cohort for structured learning with live classes, assignments, and peer discussions.',
    startDate: '2026-01-15',
    endDate: '2026-07-15',
    schedule: 'Mon, Wed, Fri · 7:00 PM IST',
    studentCount: 156,
    maxStudents: 200,
    teacherName: 'Dr. Rajesh Mehta',
    progress: 28,
    status: 'active',
  },
  {
    id: 'batch-2',
    schoolId: 'school-2',
    schoolSlug: 'jaimini',
    name: 'Advanced Jaimini Batch',
    description:
      'An intensive weekend batch for students who have completed foundational Jyotish studies.',
    startDate: '2026-02-01',
    endDate: '2026-08-01',
    schedule: 'Sat, Sun · 10:00 AM IST',
    studentCount: 48,
    maxStudents: 60,
    teacherName: 'Prof. Ananya Desai',
    progress: 8,
    status: 'active',
  },
  {
    id: 'batch-3',
    schoolId: 'school-1',
    schoolSlug: 'parashari',
    name: 'Weekend Astrology Batch',
    description: 'Flexible weekend schedule for working professionals beginning their Jyotish journey.',
    startDate: '2026-03-01',
    endDate: '2026-09-01',
    schedule: 'Sat · 4:00 PM IST',
    studentCount: 89,
    maxStudents: 100,
    teacherName: 'Dr. Rajesh Mehta',
    progress: 0,
    status: 'upcoming',
  },
];

export const mockChannels: Channel[] = [
  {
    id: 'ch-1',
    name: 'General',
    slug: 'general',
    description: 'Takshify-wide discussions and introductions',
    memberCount: 8500,
    isPinned: true,
  },
  {
    id: 'ch-2',
    name: 'Parashari Study',
    slug: 'parashari-study',
    description: 'Questions and discussions for Parashari students',
    schoolSlug: 'parashari',
    memberCount: 3200,
    isPinned: true,
  },
  {
    id: 'ch-3',
    name: 'Jaimini Research',
    slug: 'jaimini-research',
    description: 'Advanced Jaimini techniques and chart discussions',
    schoolSlug: 'jaimini',
    memberCount: 1100,
  },
  {
    id: 'ch-4',
    name: 'Announcements',
    slug: 'announcements',
    description: 'Official Takshify announcements',
    memberCount: 8500,
    isPinned: true,
  },
];

export const mockThreads: Thread[] = [
  {
    id: 'thread-1',
    channelId: 'ch-2',
    title: 'How to determine the strength of a house lord?',
    authorName: 'Arjun Sharma',
    content:
      'I am studying Lesson 2 on bhavas. When the 7th lord is in the 6th house, how should I assess its strength? Should I look at shadbala first or the dignity?',
    replyCount: 8,
    isPinned: false,
    isAnnouncement: false,
    createdAt: '2026-02-28T14:30:00Z',
  },
  {
    id: 'thread-2',
    channelId: 'ch-2',
    title: 'Batch 2026 - Week 4 Assignment Discussion',
    authorName: 'Dr. Rajesh Mehta',
    content:
      'Please post your chart analysis for the Week 4 assignment here. Focus on identifying the lagna lord and its placement.',
    replyCount: 24,
    isPinned: true,
    isAnnouncement: false,
    createdAt: '2026-02-25T10:00:00Z',
  },
  {
    id: 'thread-3',
    channelId: 'ch-4',
    title: 'New Jaimini modules launching in April',
    authorName: 'Takshify Team',
    content:
      'We are excited to announce expanded Jaimini content including pada lagna calculations and advanced chara dasha techniques.',
    replyCount: 15,
    isPinned: true,
    isAnnouncement: true,
    createdAt: '2026-02-20T09:00:00Z',
  },
];

export const mockMessages: Message[] = [
  {
    id: 'msg-1',
    threadId: 'thread-1',
    authorName: 'Dr. Rajesh Mehta',
    content:
      'Great question. Start with dignity - is the lord exalted, own sign, or debilitated? Then check shadbala. The house placement gives the context of results.',
    createdAt: '2026-02-28T15:00:00Z',
  },
  {
    id: 'msg-2',
    threadId: 'thread-1',
    authorName: 'Priya Verma',
    content:
      'I found the chapter on planetary relationships in the course notes very helpful for this. The friendship/enmity table makes it clearer.',
    createdAt: '2026-02-28T16:30:00Z',
  },
];

export const mockNotifications: Notification[] = [
  {
    id: 'notif-1',
    title: 'Live class starting soon',
    message: 'Parashari Foundation Batch 2026 - Lesson 5 begins in 30 minutes',
    type: 'live',
    isRead: false,
    createdAt: '2026-03-01T18:30:00Z',
    link: '/batches/batch-1',
  },
  {
    id: 'notif-2',
    title: 'Assignment graded',
    message: 'Your Week 3 chart analysis received 92/100',
    type: 'success',
    isRead: false,
    createdAt: '2026-02-28T12:00:00Z',
  },
  {
    id: 'notif-3',
    title: 'New reply in discussion',
    message: 'Dr. Rajesh Mehta replied to your question about house lords',
    type: 'info',
    isRead: true,
    createdAt: '2026-02-28T15:00:00Z',
    link: '/community',
  },
];

export const mockDashboard: DashboardOverview = {
  continueLearning: [
    {
      lessonId: 'lesson-2',
      lessonTitle: 'The Twelve Houses (Bhavas)',
      courseTitle: 'Parashari Foundation',
      progress: 34,
    },
  ],
  upcomingClasses: [
    {
      id: 'class-1',
      title: 'Planetary Aspects - Live Session',
      batchName: 'Parashari Foundation Batch 2026',
      scheduledAt: '2026-03-02T13:30:00Z',
      batchId: 'batch-1',
    },
  ],
  stats: {
    coursesEnrolled: 3,
    lessonsCompleted: 16,
    hoursLearned: 42,
    certificatesEarned: 1,
  },
};

export const mockCertificates: Certificate[] = [
  {
    id: 'cert-1',
    userId: 'user-1',
    courseName: 'Introduction to Vedic Astrology',
    schoolName: 'Parashari Jyotish',
    issuedAt: '2025-12-15T00:00:00Z',
    verificationCode: 'PLT-2025-PAR-0042',
  },
];

export const mockQuiz: Quiz = {
  id: 'quiz-1',
  lessonId: 'lesson-1',
  title: 'Zodiac Signs Quiz',
  questionCount: 5,
  timeLimit: 600,
  passingScore: 70,
};

export const mockQuizQuestions: QuizQuestion[] = [
  {
    id: 'q-1',
    quizId: 'quiz-1',
    question: 'Which rashi is ruled by Mars (Mangal)?',
    options: ['Mesha (Aries)', 'Vrishabha (Taurus)', 'Mithuna (Gemini)', 'Karka (Cancer)'],
    correctIndex: 0,
    explanation: 'Mars rules both Mesha (Aries) and Vrischika (Scorpio). Mesha is its moolatrikona.',
  },
  {
    id: 'q-2',
    quizId: 'quiz-1',
    question: 'What element does Karka (Cancer) belong to?',
    options: ['Fire', 'Earth', 'Air', 'Water'],
    correctIndex: 3,
    explanation: 'Cancer is a water sign (Jala tattva), along with Scorpio and Pisces.',
  },
  {
    id: 'q-3',
    quizId: 'quiz-1',
    question: 'Which planet is exalted in Mesha (Aries)?',
    options: ['Saturn', 'Sun', 'Venus', 'Moon'],
    correctIndex: 1,
    explanation: 'The Sun (Surya) is exalted at 10° of Aries.',
  },
];

export const mockFlashcards: Flashcard[] = [
  {
    id: 'fc-1',
    deckId: 'deck-1',
    front: 'What are the three fire signs (Agni rashis)?',
    back: 'Mesha (Aries), Simha (Leo), and Dhanu (Sagittarius)',
  },
  {
    id: 'fc-2',
    deckId: 'deck-1',
    front: 'Name the karaka (significator) for the 10th house',
    back: 'Sun (Surya) - represents career, authority, and public life',
  },
];

export const mockAdminUsers: AdminUser[] = [
  {
    id: 'user-1',
    email: 'arjun.sharma@example.com',
    firstName: 'Arjun',
    lastName: 'Sharma',
    roles: ['student'],
    status: 'active',
    lastLoginAt: '2026-03-01T08:00:00Z',
    createdAt: '2025-01-15T10:00:00Z',
  },
  {
    id: 'user-teacher-1',
    email: 'dr.mehta@takshify.com',
    firstName: 'Rajesh',
    lastName: 'Mehta',
    roles: ['teacher'],
    status: 'active',
    lastLoginAt: '2026-03-01T07:30:00Z',
    createdAt: '2024-06-01T10:00:00Z',
  },
  {
    id: 'user-2',
    email: 'priya.verma@example.com',
    firstName: 'Priya',
    lastName: 'Verma',
    roles: ['student'],
    status: 'active',
    lastLoginAt: '2026-02-28T20:00:00Z',
    createdAt: '2025-03-20T10:00:00Z',
  },
];

export const mockAnalytics: AdminAnalytics = {
  totalUsers: 6430,
  activeStudents: 4280,
  totalRevenue: 2450000,
  completionRate: 68,
  enrollmentsByMonth: [
    { month: 'Oct', count: 320 },
    { month: 'Nov', count: 410 },
    { month: 'Dec', count: 380 },
    { month: 'Jan', count: 520 },
    { month: 'Feb', count: 490 },
    { month: 'Mar', count: 560 },
  ],
  revenueByMonth: [
    { month: 'Oct', amount: 320000 },
    { month: 'Nov', amount: 410000 },
    { month: 'Dec', amount: 380000 },
    { month: 'Jan', amount: 520000 },
    { month: 'Feb', amount: 490000 },
    { month: 'Mar', amount: 330000 },
  ],
};

export const mockPayments: Payment[] = [
  {
    id: 'pay-1',
    userId: 'user-1',
    userName: 'Arjun Sharma',
    amount: 14999,
    currency: 'INR',
    status: 'completed',
    description: 'Parashari Foundation - Annual Plan',
    createdAt: '2026-01-10T10:00:00Z',
  },
  {
    id: 'pay-2',
    userId: 'user-2',
    userName: 'Priya Verma',
    amount: 19999,
    currency: 'INR',
    status: 'completed',
    description: 'Jaimini Karakas - Annual Plan',
    createdAt: '2026-02-01T14:00:00Z',
  },
];

export const mockBookmarks: Bookmark[] = [
  {
    id: 'bm-1',
    lessonId: 'lesson-2',
    lessonTitle: 'The Twelve Houses (Bhavas)',
    courseTitle: 'Parashari Foundation',
    createdAt: '2026-02-20T10:00:00Z',
  },
];

export const mockNotes: Note[] = [
  {
    id: 'note-1',
    lessonId: 'lesson-1',
    lessonTitle: 'Introduction to the Zodiac Signs',
    content:
      'Remember: Mesha starts at 0° Aries. Each sign is 30°. Fire signs are energetic and initiating.',
    createdAt: '2026-02-15T10:00:00Z',
    updatedAt: '2026-02-15T10:00:00Z',
  },
];

export const mockCalendarEvents: CalendarEvent[] = [
  {
    id: 'evt-1',
    title: 'Live Class - Planetary Aspects',
    type: 'live_class',
    startAt: '2026-03-02T13:30:00Z',
    endAt: '2026-03-02T15:00:00Z',
    batchName: 'Parashari Foundation Batch 2026',
    batchId: 'batch-1',
    filterKind: 'live',
    href: '/batches/batch-1',
    durationMinutes: 90,
  },
  {
    id: 'evt-2',
    title: 'Assignment Due - Chart Analysis',
    type: 'assignment',
    startAt: '2026-03-05T18:30:00Z',
    endAt: '2026-03-05T18:30:00Z',
    batchName: 'Parashari Foundation Batch 2026',
    batchId: 'batch-1',
    filterKind: 'due',
    href: '/batches/batch-1/assignments/assign-1',
  },
];

export const mockAssignments: Assignment[] = [
  {
    id: 'assign-1',
    batchId: 'batch-1',
    title: 'Week 4 - Identify Lagna Lord',
    description: 'Analyze the provided birth chart and identify the lagna lord with its placement and dignity.',
    dueDate: '2026-12-08T18:30:00Z',
    maxScore: 100,
    questionCount: 3,
    status: 'pending',
  },
  {
    id: 'assign-2',
    batchId: 'batch-1',
    title: 'Week 3 - Rashi Qualities',
    description: 'List the qualities of three rashis and their ruling planets.',
    dueDate: '2026-12-22T18:30:00Z',
    maxScore: 100,
    questionCount: 2,
    status: 'graded',
    score: 92,
    feedback: 'Strong grasp of rashi qualities.',
  },
];
